// import React, { useEffect, useRef, useState, useMemo } from "react";
// import { GoogleMap, Marker, Circle, useLoadScript } from "@react-google-maps/api";
// import { useSelector } from "react-redux";
// import { getImageByService } from "../../../assets/themes/images";
// import Pin from "../../../assets/imgs/icons/pin.png"; 

// const mapContainerStyle = {
//   width: "100%",
//   height: "100vh",
// };

// const libraries = ["places"];

// const MapViewBiddingComponent = ({
//   mapHeight = "80vh",
//   start,
//   radius,
//   driversList = [],
//   API_KEY,
// }) => {
//   const { isLoaded, loadError } = useLoadScript({
//     googleMapsApiKey: API_KEY,
//     libraries,
//   });

//   const mapRef = useRef(null);
//   const [zoomLevel, setZoomLevel] = useState(14); 
//   const [isRecentering, setIsRecentering] = useState(false);

//   // ✅ Validate the `start` prop with fallback values
//   const isValidStart = start && start.latitude && start.longitude;

//   const mapCenter = useMemo(
//     () => ({
//       lat: isValidStart ? start.latitude : 15.335,   // Fallback to default lat
//       lng: isValidStart ? start.longitude : 76.460,  // Fallback to default lng
//     }),
//     [start, isValidStart]
//   );

//   const selectedRoute = useSelector((state) => state.selectedRoute?.selectedRoute);

//   useEffect(() => {
//     if (mapRef.current && isValidStart) {
//       mapRef.current.panTo(mapCenter);
//     }
//   }, [mapCenter, isValidStart]);

//   useEffect(() => {
//     if (mapRef.current) {
//       let newZoom = 13;

//       if (radius <= 1000) {
//         newZoom = 14;  // Zoom in for smaller radius
//       } else if (radius <= 3000) {
//         newZoom = 13;  // Medium radius
//       } else if (radius <= 5000) {
//         newZoom = 12;  // Slightly zoom out
//       } else if (radius <= 10000) {
//         newZoom = 11;  // Larger radius
//       } else {
//         newZoom = 10;  // Farther out
//       }

//       // Animate Zoom Transition
//       mapRef.current.setZoom(newZoom);
//       setZoomLevel(newZoom);
//     }
//   }, [radius]);

//   console.log("driversList", driversList);

//   // ✅ Memoize the driver markers
//   const driverMarkers = useMemo(
//     () =>
//       driversList?.map((driver) => ({
//         key: driver.id,
//         position: {
//           lat: driver.current_location.latitude || 0,  // Ensure valid lat
//           lng: driver.current_location.longitude || 0, // Ensure valid lng
//         },
//         icon: {
//           url: getImageByService("CAR"),
//           scaledSize: new window.google.maps.Size(40, 40),
//         },
//         // label: driver.first_name,
//       })),
//     [driversList]
//   );

//   const handleRecenter = () => {
//     if (mapRef.current && isValidStart) {
//       setIsRecentering(true);

//       // Smooth pan and zoom to the starting point
//       mapRef.current.panTo(mapCenter);
//       mapRef.current.setZoom(zoomLevel);

//       setTimeout(() => {
//         setIsRecentering(false);
//       }, 1000);
//     }
//   };

//   if (loadError) return <p>Error loading maps</p>;
//   if (!isLoaded) return <p>Loading Maps...</p>;

//   return (
//     <div className="w-full h-full">
//       <div
//         style={{
//           width: "100%",
//           height: mapHeight,
//           borderRadius: "20px",   // Curved edges
//           overflow: "hidden",      // Ensures map doesn't exceed the border
//         }}
//         className="shadow-lg"
//       >
//       <GoogleMap
//         mapContainerStyle={{ ...mapContainerStyle, height: mapHeight }}
//         zoom={zoomLevel}
//         center={mapCenter}
//         options={{
//           disableDefaultUI: true,
//           draggable: true,
//           zoomControl: true,
//           mapTypeControl: false,
//           // mapTypeControl: true,
//           fullscreenControl: false,
//           streetViewControl: false,
         
//         //   styles: [
//         //     {
//         //       elementType: "geometry",
//         //       stylers: [{ color: "#242f3e" }],
//         //     },
//         //     {
//         //       elementType: "labels.text.stroke",
//         //       stylers: [{ color: "#242f3e" }],
//         //     },
//         //     {
//         //       elementType: "labels.text.fill",
//         //       stylers: [{ color: "#746855" }],
//         //     },
//         //   ],
//         }}
//         onLoad={(map) => (mapRef.current = map)}
//       >
//         {/* ✅ Render Start Marker & Circle only if `start` is valid */}
//         {isValidStart && (
//           <>
//             <Marker
//               position={{ lat: start.latitude, lng: start.longitude }}
//               icon={{
//                 url: Pin,   // ✅ Custom pin for start location
//                 scaledSize: new window.google.maps.Size(50, 50),  // Larger start pin
//               }}
//             />
//             <Circle
//               center={{ lat: start.latitude, lng: start.longitude }}
//               radius={radius}
//               options={{
//                 strokeColor: "#1E90FF",
//                 strokeOpacity: 0.8,
//                 strokeWeight: 2,
//                 fillColor: "#1E90FF",
//                 fillOpacity: 0.35,
//               }}
//             />
//           </>
//         )}

//         {/* Driver Markers */}
//         {driverMarkers.map((marker) => (
//           <Marker
//             key={marker.key}
//             position={marker.position}
//             icon={marker.icon}
//             // label={marker.label}
//           />
//         ))}
//       </GoogleMap>
//       </div>
//       <button
//         onClick={handleRecenter}
//         className={`absolute bottom-5 right-5 bg-blue-600 text-white p-3 rounded-full shadow-lg transition-transform ${
//           isRecentering ? "scale-90" : "scale-100"
//         } hover:scale-110 focus:outline-none`}
//         title="Recenter Map"
//       >
//         🔄
//       </button>
//     </div>
//   );
// };

// // ✅ Memoized Export
// const MapViewBidding = React.memo(MapViewBiddingComponent);
// export default MapViewBidding;


import React, { useEffect, useRef, useState, useMemo } from "react";
import { GoogleMap, Marker, Circle, useLoadScript } from "@react-google-maps/api";
import { useSelector } from "react-redux";
import { getImageByService } from "../../../assets/themes/images";
import Pin from "../../../assets/imgs/icons/pin.png";
import { MdMyLocation } from "react-icons/md";

const mapContainerStyle = {
  width: "100%",
  height: "100vh",
};

const libraries = ["places"];

const MapViewBiddingComponent = ({
  mapHeight = "80vh",
  start,
  radius,
  driversList = [],
  API_KEY,
}) => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: API_KEY,
    libraries,
  });

  const mapRef = useRef(null);
  const [zoomLevel, setZoomLevel] = useState(14);
  const [isRecentering, setIsRecentering] = useState(false);

  // ✅ Validate the `start` prop with fallback values
  const isValidStart = start && start.latitude && start.longitude;

  const mapCenter = useMemo(
    () => ({
      lat: isValidStart ? start.latitude : 15.335, // Fallback lat
      lng: isValidStart ? start.longitude : 76.460, // Fallback lng
    }),
    [start, isValidStart]
  );

  const selectedRoute = useSelector((state) => state.selectedRoute?.selectedRoute);

  useEffect(() => {
    if (mapRef.current && isValidStart) {
      mapRef.current.panTo(mapCenter);
    }
  }, [mapCenter, isValidStart]);

  useEffect(() => {
    if (mapRef.current) {
      let newZoom = 13;

      if (radius <= 1000) {
        newZoom = 14;
      } else if (radius <= 3000) {
        newZoom = 13;
      } else if (radius <= 5000) {
        newZoom = 12;
      } else if (radius <= 10000) {
        newZoom = 11;
      } else {
        newZoom = 10;
      }

      mapRef.current.setZoom(newZoom);
      setZoomLevel(newZoom);
    }
  }, [radius]);

  console.log("driversList", driversList);

  // ✅ Memoize the driver markers
  const driverMarkers = useMemo(
    () =>
      driversList?.map((driver) => ({
        key: driver.id,
        position: {
          lat: driver.current_location.latitude || 0,
          lng: driver.current_location.longitude || 0,
        },
        icon: {
          url: getImageByService("CAR"),
          scaledSize: new window.google.maps.Size(40, 40),
        },
      })),
    [driversList]
  );

  const handleRecenter = () => {
    if (mapRef.current && isValidStart) {
      setIsRecentering(true);

      // Smooth pan and zoom to the starting point
      mapRef.current.panTo(mapCenter);
      mapRef.current.setZoom(zoomLevel);

      setTimeout(() => {
        setIsRecentering(false);
      }, 1000);
    }
  };

  if (loadError) return <p>Error loading maps</p>;
  if (!isLoaded) return <p>Loading Maps...</p>;

  return (
    <div className="relative w-full h-full">
      <div
        style={{
          width: "100%",
          height: mapHeight,
          borderRadius: "20px",
          overflow: "hidden",
        }}
        className="shadow-lg"
      >
        <GoogleMap
          mapContainerStyle={{ ...mapContainerStyle, height: mapHeight }}
          zoom={zoomLevel}
          center={mapCenter}
          options={{
            disableDefaultUI: true,
            draggable: true,
            zoomControl: true,
            mapTypeControl: false,
            // mapTypeControl: true,
            fullscreenControl: false,
            streetViewControl: false
           }}

          onLoad={(map) => (mapRef.current = map)}
        >
          {/* ✅ Start Marker and Circle */}
          {isValidStart && (
            <>
              <Marker
                position={{ lat: start.latitude, lng: start.longitude }}
                icon={{
                  url: Pin,
                  scaledSize: new window.google.maps.Size(50, 50),
                }}
              />
              <Circle
                center={{ lat: start.latitude, lng: start.longitude }}
                radius={radius}
                options={{
                  strokeColor: "#1E90FF",
                  strokeOpacity: 0.8,
                  strokeWeight: 2,
                  fillColor: "#1E90FF",
                  fillOpacity: 0.35,
                }}
              />
            </>
          )}

          {/* Driver Markers */}
          {driverMarkers.map((marker) => (
            <Marker
              key={marker.key}
              position={marker.position}
              icon={marker.icon}
            />
          ))}
        </GoogleMap>

        {/* ✅ Recenter Button Above Zoom Controls */}
        <div
          className="absolute right-2 bottom-28 z-10"
          style={{ zIndex: 10 }}
        >



          <button
            onClick={handleRecenter}
            className={`bg-gray-50 p-3 rounded-full  transition-transform ${
              isRecentering ? "scale-90" : "scale-100"
            } hover:scale-110 focus:outline-none`}
            title="Recenter Map"
          >
            <MdMyLocation size={22} />
          </button>
        </div>
      </div>
    </div>
  );
};

const MapViewBidding = React.memo(MapViewBiddingComponent);
export default MapViewBidding;

